<template>
  <div class="step2" >
  <!-- <button id="show-modal" @click="openPrintOutModal = true">Show Modal</button> -->
  <!-- use the modal component, pass in the prop -->
  <popup :selectedAmulets="selectedAmulets" :storeType = "storeType" :addToCartLink="addToCartLink" v-if="openPrintOutModal" :confirmationNum="confirmationNum" :downloadFileName="downloadFileName" :printoutPdfFileName="printoutPdfFileName" @close="openPrintOutModal = false" v-on:downloadPrint="downloadPrint" v-on:getPreviewForCart="getPreviewForCart" v-on:createNew="startOver">
    <!--
      you can use custom content here to overwrite
      default content
    -->
    <!-- <h3 slot="header">Your design has been saved</h3> -->
    <!-- <h3 slot="body"></h3> -->
  </popup>

  <popupAmulets :selectedAmulets="selectedAmulets" @goCheckOut="goCheckOut" v-if="loadingAmuletModal" class="loadingModal" @close="loadingAmuletModal = false"></popupAmulets>
  <popup v-if="loadingModal"  class="loadingModal" @close="loadingModal = false">
    <!--
      you can use custom content here to overwrite
      default content
    -->
    <div slot="header"></div>
    <h3 slot="body">{{loadingText}}</h3>
    <h3 slot="footer"><span @click="loadingModal=false"><u></u></span></h3>
  </popup>
    <div class="masks" v-if="data != null">
      <span class="title" v-if="data != null && data[currSide].userInputType==1">2. Size &amp; Set Your Photos</span>
      <span class="title" v-if="data != null &&  data[currSide].userInputType==2">2. Preview your locket</span>
      <label style="min-width:130px">ACTIVE IMAGES: </label>
      <div v-if="styleNumObj.sides >= 4" class="mask leftside" :class="{selected: currSide==3}" @click="switchSide(3)"><img :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_preview3.png?xyz'"/></div>
      <div v-if="styleNumObj.sides >= 3" class="mask leftside" :class="{selected: currSide==2}" @click="switchSide(2)"><img :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_preview2.png?xyz'"/></div>
      <div v-if="styleNumObj.sides >= 2" class="mask leftside" :class="{selected: currSide==1}" @click="switchSide(1)"><img :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_preview1.png?xyz'"/></div>
      <div class="mask rightside" :class="{selected: currSide==0}" @click="switchSide(0)"><img :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_preview0.png?xyz'"/></div>
      <div class="c c4" v-if="data[currSide].userInputType == 2">
          <div class="error" v-if="errorMsg != null">{{errorMsg}}</div>
          <button class=" nextStepBtn" :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" @click="lastStep(currSide + 1)" v-if="showBtnToGoBack && data[currSide].saved">Design other side </button>
          <div v-if="readyToPrint && data[currSide].saved" style="display:inline-block;">
            <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="saveNprint" >Finish</button>
          </div>
          <button class="save" @click="startOver()">Start Over</button>
          <button v-if="data != null && data[currSide].userInputType==1" @click="lastStep(currSide)" class="">Choose a different image</button>
          <button v-if="data != null && data[currSide].userInputType==2" @click="lastStep(currSide)"  class="">Change message</button>
      </div>
    </div>
    <!-- canvas-->
    <div style="overflow:hidden" v-show="data != null && data[currSide].userInputType==1">
      <div class="control" v-if="data != null && data[currSide].userInputType==1">
        <div class="c c1">
          <label for="">Scale Image:</label>
          <i class="fa" >A</i>
          <input type="range" min="1" max="100" value="100" v-model="scaleValue" @mouseup=""/>
          <i class="fa" >A</i>
        </div>
        <div class="c c2">
          <label for="">Rotate Image:</label>
          <i class="fa fa-undo" aria-hidden="true"></i>
          <input type="range" min="0" max="360" value="0" v-model="rotateValue" @mouseup="">
          <i class="fa fa-undo" aria-hidden="true"></i>
          
        </div>
        <div class="c">
          <label for="">Convert Color:</label>
          <span v-if="!grayscale" class="grayscale" @click="toggleblacknwhite">Black and white</span><span v-if="grayscale" class="grayscale" @click="toggleblacknwhite">Color</span> | 
          <span class="reset" @click="reset">Reset</span>
          <div class="c c3">
            <div class="error" v-if="errorMsg != null">{{errorMsg}}</div>
              <button class="nextStepBtn" v-if="data != null && data[currSide].userInputType==1 && !data[currSide].saved" @click="getPreview1(currSide)">Save</button>
              <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="lastStep(currSide + 1)" v-if="showBtnToGoBack && data[currSide].saved">Design other side</button>
              <div v-if="readyToPrint && data[currSide].saved" style="display:inline-block;">
                <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="saveNprint" v-if="storeType == 2 || storeType == 3">Finish</button>
                <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="saveNprint" v-if="storeType == 1">Add to cart</button>
              </div>
              <button class="save" @click="startOver()">Start Over</button>
              <button v-if="data != null && data[currSide].userInputType==1" @click="lastStep(currSide)" class="">Choose a different image</button>
              <button v-if="data != null && data[currSide].userInputType==2" @click="lastStep(currSide)"  class="">Change message</button>
          </div> 
        </div>
      </div>
    
      <div class="playground" :style="playgroundStyle('locketMask3')" v-show="currSide == 3" >
        <img :style="maskStyle('locketMask3')" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask1.png'" id="locketMask3" class="locketMask1" v-if="currSide == 3" /><canvas id="left3"  style="display:block;" :class="{grayscale:grayscale}"></canvas>
      </div>
      <div class="playground" :style="playgroundStyle('locketMask2')" v-show="currSide == 2" >
        <img :style="maskStyle('locketMask2')" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask1.png'" id="locketMask2" class="locketMask1" v-if="currSide == 2" /><canvas id="left2"  style="display:block;" :class="{grayscale:grayscale}"></canvas>
        
      </div>
      <div class="playground" :style="playgroundStyle('locketMask1')" v-show="currSide == 1" >
        <img :style="maskStyle('locketMask1')" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask1.png'" id="locketMask1" class="locketMask1" v-if="currSide == 1 && styleNumObj.styleNum != 'jm0068'"  /><img :style="maskStyle('locketMask2')" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask1_1.png'" id="locketMask2" class="locketMask1" v-else /><canvas id="left"  style="display:block;" :class="{grayscale:grayscale}"></canvas>
      
      </div>
      <div class="playground" :style="playgroundStyle('locketMask0')" v-show="currSide == 0">
        <img :style="maskStyle('locketMask0')" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_mask1.png'" id="locketMask0" class="locketMask1" v-if="currSide == 0"><canvas id="right" :class="{grayscale:grayscale}" width=800 height=400 style="max-width:100%; width: 800px; height:400px;max-height:100%;display:block;"></canvas>
      </div>
    </div>

    <!-- text-->
    <div v-if="data != null" v-show="data[currSide].userInputType==2">
        <div class="playground playgroundText" :style="playgroundStyle('textCanvas')">
          <span class="text1"  :class="{small: styleNumObj.size=='s', large: styleNumObj.size=='l', xlarge:  styleNumObj.size=='xl', xxlarge:  styleNumObj.size=='xxl'}">
            <span :style="data[currSide].selectedFont">{{data[currSide].userInputText1}}</span>
            <span :style="data[currSide].selectedFont">{{data[currSide].userInputText2}}</span>
            <span :style="data[currSide].selectedFont">{{data[currSide].userInputText3}}</span>
          </span>
          <canvas id="textCanvas"  style="display:block;" :class="{grayscale:grayscale}"></canvas>
        </div>
    </div>
    <div class="control c1" v-if="data != null">
        <div class="c c4 mobile">
          <button class="nextStepBtn" v-if="data != null && data[currSide].userInputType==1 && !data[currSide].saved" @click="getPreview1(currSide)">Save</button>
          <button class=" nextStepBtn" :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" @click="lastStep(currSide + 1)" v-if="showBtnToGoBack && data[currSide].saved">Design other side </button>
          <div v-if="readyToPrint && data[currSide].saved" style="display:inline-block;">
            <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="saveNprint()" v-if="storeType == 1">Add to cart</button>
            <button :class="{unsaved: !data[currSide].saved}" :disabled="!data[currSide].saved" class="nextStepBtn" @click="saveNprint()" v-if="storeType == 2 || storeType == 3">Finish</button>
          </div>
          <button v-if="data != null && data[currSide].userInputType==1" @click="lastStep(currSide)" class="">Choose a different image</button>
          <button v-if="data != null && data[currSide].userInputType==2" @click="lastStep(currSide)"  class="">Change message</button>
          <button class="" @click="startOver()">Start Over</button>
        </div>
    </div>
  </div>
</template>
<script>
// import popup from './popup'
import popup from '@/components/popup.vue'
import popupAmulets from '@/components/popupAmulets.vue'

export default {
  name: 'Step2',
  components: {popup, popupAmulets},
  props: {
    currSideG: Number,
    reloadObj: null,
    styleNumObj: null,
    storeType: Number,
    userData: Array,
    theCanvasG: Array,
    theCanvasPreview: Array,
    orderQuantity: Number,
    theCanvasPreviewRendered: Number
  },
  data: function () {
    return {
      pageRefresh: 10,
      originalScaleValue: 100,
      scaleValue:100,
      rotateValue: 0,
      theCanvas: [],
      theImgs: [],
      grayscale: false,
      errorMsg: null,
      printoutPdfFileName: '',
      downloadFileName:'',
      openPrintOutModal: false,
      previewFileName0: null,
      previewFileName1: null,
      loadingModal: false,
      loadingAmuletModal: false,
      loadingText: 'Please wait.  Your image is being rendered',
      testData: null,
      data: null,
      currSide: 0,
      saved0: false,
      saved1: false,
      canvasCreated0: false,
      canvasCreated1: false,
      canvasCreated2: false,
      canvasCreated3: false,
      confirmationNum: '',
      selectedAmulets: null
    }
  },
  computed: {
    addToCartLink() {
        // return "https://www.brighton.com/cart?add="+this.styleNumObj.torreyProductID+":"+this.orderQuantity+"&transnumber="+this.confirmationNum+"&type=lockets";
        // return `https://brighton-collectibles.myshopify.com/pages/br-custom-atc?brightonCustom=1&variantId=43276706971880&designId=ABC123&otherData={%27key1%27:%27value1%27,%27key2%27:%27value2%27,%27key3%27:%27value3%27}`;
        return `https://brighton-collectibles.myshopify.com/pages/br-custom-atc?brightonCustom=1&variantId=${this.styleNumObj.shopifyVariantID}&designId=${this.confirmationNum}&otherData={%27thumbnailImg%27:%27https%3A%2F%2Fapp.brighton.com%2Fapi%2Fpreview%2F%3FconfirmationNum%3D${this.confirmationNum}%26type%3Dlockets%27}&${Math.floor(Math.random() * 100000000000)}`;
      
      },
    readyToPrint() {
      if(this.styleNumObj != null && this.data != null){
        for(let side = 0; side < parseInt(this.styleNumObj.sides); side++){
          if(this.data[side].userInputType == 1 && (this.data[side].userImage == '' || this.data[side].userImage == null))
            return false
        }
      }
      return true
    },
    showBtnToGoBack() {
      if(this.styleNumObj != null && this.data != null){
        for(let side = 0; side < parseInt(this.styleNumObj.sides); side++){
          if(this.data[side].userInputType == 1 && (this.data[side].userImage == '' || this.data[side].userImage == null))
            return true
        }
      }
      return false
    }
  },
  watch: { 
    currSideG: function (newVal){
      this.currSide = this.currSideG
    },
    scaleValue: function (newVal) {
      this.data[this.currSide].scaleValue = newVal
      this.move(newVal / 100, this.rotateValue)
    },
    rotateValue (newVal) {
      this.data[this.currSide].rotateValue = newVal
      this.move(this.scaleValue / 100, newVal);
    },
  },
  mounted (){
    console.log('mounted 2')
    var that = this
    var imageUrl0, imageUrl1;
    this.currSide = this.currSideG
    if(this.theCanvasG != null){
     this.theCanvas = this.theCanvasG
    }
    if(this.userData != null) {
      this.data = JSON.parse(JSON.stringify(this.userData))
      this.$nextTick(function() {
        if(that.data[that.currSide].userInputType == 2){
          that.data[that.currSide].saved = true
          that.$forceUpdate()
        }
        var oldCanvas='', oldSetting='', oldDefaultSetting=''
        // the other sides, make canvas ready but don't generate preview
        for(let theOtherSide = 0; theOtherSide < this.data.length; theOtherSide ++) {
          if(theOtherSide != that.currSide) {
            if(that.data[theOtherSide].userInputType == 1 && that.data[theOtherSide].userImage != null) { 
              if(this.theCanvas[theOtherSide] != null) {
                oldCanvas = this.theCanvas[theOtherSide]
                oldSetting = that.theCanvas[theOtherSide].canvas.toJSON()
                oldDefaultSetting = oldSetting.defaultSetting
              }
              imageUrl0 = 'https://app.brighton.com/lockets/tmp/'+that.data[theOtherSide].userImage
              that.canvasCreated1 = false
              console.log('theotherside', theOtherSide)
              that.getCanvas(imageUrl0, theOtherSide, (canvas, currside)=>{
                // theOtherSide
                if(oldCanvas != '') {}
                console.log(currside, that.theCanvas[currside].left)
                if(that.theCanvas[currside].left != null) {
                  that.absMoveImage(that.theCanvas[currside].left, that.theCanvas[currside].top, currside)
                } 
                canvas.setActiveObject(canvas.item(0));
                that.getPreview1(currside)
              });
            }
          }
        }



        if(that.data[this.currSide].userInputType == 1 && that.data[this.currSide].userImage != null) { 
          if(this.theCanvas[this.currSide] != null) {
            oldCanvas = this.theCanvas[this.currSide]
            oldSetting = that.theCanvas[this.currSide].canvas.toJSON()
          }
          imageUrl0 = 'https://app.brighton.com/lockets/tmp/'+that.data[that.currSide].userImage
          that.scaleValue = that.data[that.currSide].scaleValue
          that.originalScaleValue = that.data[that.currSide].scaleValue
          that.rotateValue = that.data[that.currSide].rotateValue
          that.grayscale = that.data[that.currSide].grayscale
          that.getCanvas(imageUrl0, this.currSide,  (canvas, currside) => {
            // that.currSide
            if(that.theCanvas[currside].left != null) {
              that.absMoveImage(that.theCanvas[currside].left, that.theCanvas[currside].top, currside)
            } 
            that.getPreview1(currside)
          });
        }
        // textCanvas
        that.getCanvas('https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum+'_mask1.png', 'textCanvas', (canvas, currside) => {})
        document.body.scrollTop = 500 // For Safari
        document.documentElement.scrollTop = 500 // For Chrome, Firefox, IE and Opera
      })
    }
  },
  methods: {
    playgroundStyle(divID) {
      let img = document.getElementById(divID)
      if(img != null) {
        let weight = img.clientWidth, 
        height = img.clientHeight; 
        if((height/2) > 156)
          return {
            top: 0 + 'px',
            'margin-bottom': 0 + 'px',
            height: height + 'px'
          }
      } else {
        return {}
      }
    },
    maskStyle(divID){
      var img = document.getElementById(divID); 
      if(img != null) {
        var width = img.clientWidth;
        var height = img.clientHeight;
        return {
          'z-index':this.pageRefresh,
          'margin-left': '-' + ((this.styleNumObj.maskSize / 2) - 3 )+ 'px',
          'margin-top': '-'+ (((this.styleNumObj.maskSizeHeight == 0 ? this.styleNumObj.maskSize : this.styleNumObj.maskSizeHeight) / 2) -3 ) + 'px'
        }
      } else {
        return {
          'z-index':this.pageRefresh
        }
      }
    },
    addToCart() {
      document.location.replace(this.addToCartLink)
    },
    switchSide(side) {
      var that = this
      if(this.currSide != side) {
        this.currSide = side
        this.scaleValue = this.data[side].scaleValue
        this.rotateValue = this.data[side].rotateValue
        this.grayscale = this.data[side].grayscale
        this.$nextTick(function (){
          that.data[side].saved = true
          that.$forceUpdate()
        })
      }




      this.$forceUpdate()
    },
    reset(){
      var that = this
      that.scaleValue = that.originalScaleValue
      that.rotateValue = 0
      that.grayscale = false
      that.data[that.currSide].grayscale = that.grayscale
      that.absMoveImage(that.theCanvas[that.currSide].left, that.theCanvas[that.currSide].top, that.currSide)
    },
    toggleblacknwhite () {
      this.grayscale = !this.grayscale
      this.data[this.currSide].grayscale = this.grayscale
      this.makeGrayscale()
    },
    makeGrayscale () {
        var that = this
         // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;
        var obj = this.theCanvas[this.currSide].canvas._objects[0]
        var filter = new fabric.Image.filters.Grayscale();
        if(this.grayscale) {
          obj.filters.push(filter)
        } else {
          obj.filters = []
        }
        obj.applyFilters()
        this.getPreview1(this.currSide)
        this.theCanvas[this.currSide].canvas.renderAll();
    },
    move (sv, rv) {
      // sv - scalevalue ...between 0 - 1
      // rv - rotateValue .. 0 - 360
      if(this.theCanvas[this.currSide] != null) {
        var obj = this.theCanvas[this.currSide].canvas._objects[0];
        var angle = obj.get('angle');
        obj.set('angle', rv);
        obj.set('scaleX', sv);
        obj.set('scaleY', sv); 
        this.theCanvas[this.currSide].canvas.renderAll();
      }
    },
    absMoveImage(x, y, side) {
       var obj = this.theCanvas[side].canvas._objects[0];
        var xCoord = obj.get('left');
        var yCoord = obj.get('top');
        obj.set('angle', this.data[side].rotateValue);
        obj.set('scaleX', this.data[side].scaleValue/ 100) ;
        obj.set('scaleY', this.data[side].scaleValue/ 100) ; 
        obj.set('top', y); 
        obj.set('left', x);
        this.theCanvas[side].canvas.renderAll(); 
    },
    moveImage(x, y) {
       var obj = this.theCanvas[this.currSide].canvas._objects[0];
        var xCoord = obj.get('left');
        var yCoord = obj.get('top');
        obj.set('angle', this.data[this.currSide].rotateValue);
        obj.set('scaleX', this.data[this.currSide].scaleValue/ 100) ;
        obj.set('scaleY', this.data[this.currSide].scaleValue/ 100) ; 
        obj.set('top', yCoord + y); 
        obj.set('left', xCoord + x);
        this.theCanvas[this.currSide].canvas.renderAll(); 
    },
    getPreviewForCart: function (addToCartLinkObj) {
      var that = this
      var openWindow;
      var apiURL = 'https://app.brighton.com/lockets/api/getPreview1';
      var formData;
      let previewCompleted = 0;

      if(this.theCanvas.length == 0) {
        window.location.assign(addToCartLinkObj.addToCartLink)
      } else {
        for(let side = 0; side < this.theCanvas.length; side ++) {
          if(this.data[side] != null && this.data[side].userInputType == 1) {
            formData = 
            {data: [ 
              {
                confirmationNum: this.confirmationNum,
                selectedUserInputType: this.data[side].userInputType,
                setting: that.theCanvas[side].canvas.toJSON(),
                userImage: that.data[side].userImage,
                grayscale: that.data[side].grayscale,
                rotateValue: that.data[side].rotateValue,
                scaleValue: that.data[side].scaleValue,
                styleNumObj: that.styleNumObj,
                currSide: side,
              }
            ]}
            this.$http.post(
              apiURL,
              formData
              ,
              {emulateJSON: true}
            ).then(response => {
              previewCompleted ++;
              if(previewCompleted == that.theCanvas.length)
                window.location.assign(addToCartLinkObj.addToCartLink)
            })
          } else {
            previewCompleted ++;
            if(previewCompleted == that.theCanvas.length)
              window.location.assign(addToCartLinkObj.addToCartLink)
          } 
          
        }
      }
    },
    getPreview1: function(side) {
      console.log('getPreview1')
      // update text version image
      var obj = this.theCanvas[side].canvas._objects[0];
      var top = obj.get('top');
      var left = obj.get('left');
      this.theCanvas[side].top = top
      this.theCanvas[side].left = left
      this.theCanvas[side].defaultSetting = this.theCanvas[side].canvas.toJSON()
      this.$emit('setUserData', this.theCanvas, this.data) 
      this.data[side].saved = true
      if(side == 0){
        this.$emit('setPreviewUserImg', 
        {
          url1: '',
          url1Top: '',
          url2: ''
        });
      } else {
        this.$emit('setPreviewUserImg', 
        {
          url2: '',
          url1Top:'',
          url1: ''
        });
      }

      // update canvas 
      var obj = this.theCanvas[side].canvas._objects[0];
      var xCoord = obj.get('left');
      var yCoord = obj.get('top');
      // console.log(`preview ${side} ${xCoord} ${yCoord}`)
      var that = this
      let url1 = 'https://app.brighton.com/lockets/tmp/'+this.userData[this.currSide].userImage
      let url = 'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_preview1.png'
      let canvas = new fabric.Canvas('preview')
      console.log(url1, url)
      // canvas.setHeight(300);
      // canvas.setWidth(300);
      canvas.setHeight(1200);
      canvas.setWidth(1200);
      fabric.textureSize = 4096
      fabric.Image.fromURL(url1, (oImg) => {
        oImg.set({left: ((canvas.width / 2)), top: canvas.height /2, originX: 'center', originY: 'center'});
        canvas.add(oImg);
        var objs = canvas._objects;
        // canvas.item(0).set('scaleX', that.data[that.currSide].scaleValue / 100);
        // canvas.item(0).set('scaleY', that.data[that.currSide].scaleValue / 100); 
        canvas.item(0).set('angle', that.data[that.currSide].rotateValue);
        canvas.item(0).set('top', yCoord - ((500 - 300)/2) - 3); 
        canvas.item(0).set('left', xCoord - ((800 - 300)/2) - 3);
        fabric.Image.fromURL(url, function(oImg) {
          oImg.set({left: ((canvas.width / 2)), top: canvas.height /2, originX: 'center', originY: 'center'});
          canvas.add(oImg);
          canvas.forEachObject(function(object){ 
              object.selectable = false; 
              object.hasControls = false;
          });
          var isIE = /*@cc_on!@*/false || !!document.documentMode;
          // Edge 20+
          var isEdge = !isIE && !!window.StyleMedia;
          var filter = new fabric.Image.filters.Grayscale();
          if(that.grayscale) {
            // obj.filters.push(filter)
            obj.filters = []
            obj.filters.push(filter)
          } else {
            obj.filters = []
          }
          obj.applyFilters()
        })
      })
      this.$emit('setPreviewUserImgs')
      this.$forceUpdate()
    },
    downloadPrint() {
      this.$http.post(
        'https://app.brighton.com/lockets/api/downloadPrint',
        {confirmationNum: this.confirmationNum},
        {emulateJSON: true}
      ).then(response => {
          window.open(this.downloadFileName)
      })
    },
    saveNprint() {
      var that = this
      var openWindow;
      var oldLoadingText = this.loadingText
      this.loadingText = "Please wait.  Your design is being saved"
      this.loadingModal = true
      var formData = JSON.parse(JSON.stringify(this.data));
      formData[0].styleNumObj = this.styleNumObj
      formData[0].storeType = this.storeType
      let allRendered = true
      for(let side = 0; side < parseInt(this.styleNumObj.sides); side ++) {
        if(this.data[side].userInputType == 1){
          formData[side].setting = this.theCanvas[side].canvas.toJSON()
          formData[side].setting1 = JSON.stringify(this.theCanvasPreview[side].toJSON())
          // console.log(this.theCanvasPreview[side].toJSON().objects.length)
          if(this.theCanvasPreview[side].toJSON().objects.length != 2 || this.theCanvasPreviewRendered < 4) {
            console.log(`preview canvas not ready. wait 1000 ms ${this.theCanvasPreviewRendered}`)
            setTimeout(()=>{
              this.saveNprint()
            }, 1000)
            return false;
          }
        }
      }
      
        // don't think its needed anymore
        // formData[0].previewFileName = this.previewFileName0
        // formData[1].previewFileName = this.previewFileName1
        formData[0].platform = navigator.platform
        formData[0].vendor = navigator.vendor
        formData[0].currSide = 0;
        // send browser version
        var ua= navigator.userAgent, tem, 
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        formData[0].browserVersion = M.join(' ')
        formData = {data: formData}


        
        
        this.$http.post(
          // 'https://jhsu-ms-app-brighton-com.staging.brightoncollectibles.com/lockets/api/saveNprint',
          'https://app.brighton.com/lockets/api/saveNprint',
          formData,
          {emulateJSON: true}
        ).then(response => {
          that.printoutPdfFileName = baseURL+'/print/'+response.body.confirmationNum + '/large'
          that.downloadFileName = '/lockets/tmp/'+response.body.confirmationNum+'.jpg'
          that.confirmationNum = response.body.confirmationNum
          that.loadingModal = false
          that.loadingText = oldLoadingText
          // if(that.storeType == 1 && parseInt(that.styleNumObj.canAddAmulet) == 1) {
          //   that.loadingAmuletModal = true
          // } else {
          //   that.openPrintOutModal = true
          // }
          that.openPrintOutModal = true
        }) 
     


    },
    goCheckOut(amulets) {
       this.loadingAmuletModal = false
       this.selectedAmulets = []
       if(amulets != null) {
        amulets.forEach(amulet => {
          amulet.selected ? this.selectedAmulets.push(amulet) : null
        })
       }
       this.openPrintOutModal = true
    },
    startOver() {
      this.$emit('startOver')
    },
    lastStep(side) {
      
      this.$emit('lastStep', side);
    },
    
    getCanvas: function (url, side, callBack) {
      var divID = 'left'
      var that = this
      var canvas;
      if(side == 0)
        divID = 'right'
      else if(side == 1)
        divID = 'left'
      else if (side == 2) {
        divID = 'left2'
      } else if (side == 3) 
        divID = 'left3'
      else
        divID = side

      this.originalScaleValue = 101
      canvas = new fabric.Canvas(divID, {preserveObjectStacking: true,controlsAboveOverlay: true});
      canvas.setHeight(500);
      canvas.setWidth(800);
      fabric.textureSize = 4096
      fabric.Image.fromURL(url, function(oImg) {
        oImg.set({left: ( (canvas.width / 2)), top: canvas.height /2, originX: 'center', originY: 'center'});
        canvas.add(oImg);

        // if scale is 100, scale to be as close as to the mask
        let offsetScaleRatio = 1
        if(!isNaN(side) && that.data[side].scaleValue > 100) { // if either side == 0 or 1
          offsetScaleRatio = that.styleNumObj.maskSize * 2 / oImg.getOriginalSize().width
          offsetScaleRatio = offsetScaleRatio > 1 ? 1 : offsetScaleRatio
          that.scaleValue = that.offsetScaleRatio  * 100 > 100 ? 100 : offsetScaleRatio * 100
          that.data[side].scaleValue = that.scaleValue
          that.originalScaleValue = offsetScaleRatio * 100 > 100 ? 100 : offsetScaleRatio * 100
        }

        canvas.hoverCursor = 'pointer';
        canvas.item(0).hasControls = false;
        canvas.item(0).set('scaleX', offsetScaleRatio);
        canvas.item(0).set('scaleY', offsetScaleRatio); 
        canvas.item(0).set('angle', 0);
        // canvas.on('object:added', function(){})
        canvas.on('after:render', function(){
          if(!isNaN(side)) {
            that.data[side].saved = false
            if(that.theCanvas[side] == null){
              that.theCanvas[side] = {canvas: canvas, defaultSetting: canvas.toJSON()}
            }
            else {
              that.theCanvas[side].canvas = canvas
              that.theCanvas[side].defaultSetting = canvas.toJSON()
            }
          }

          
          // we only want to get preview once after rendered
          if(that['canvasCreated'+side] == false) {
            that['canvasCreated'+side] = true
            callBack(canvas, side)
          }




          that.$forceUpdate();
        });
      });

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  outline-style:none;
box-shadow:none;
border-color:transparent;
}
button{
  transition: all 0.3s;
  /*display:block;*/
  /*width:100%;*/
  margin-bottom:10px;
  border-radius: 4px;
  opacity:0.8;
}
button:hover{
  opacity:1;
}
  button.save{
    /* float:right; */
  }
 button.nextStepBtn{
  /*border:1px solid red;*/
  /*font-size:20px;*/
  /*width:100%;*/
  background-color:#cd8b62;
}
button.unsaved{
  background-color:#999;
  cursor: not-allowed;
}

  span.reset,
  span.grayscale{
    /*border:1px solid #000;*/
    /*background-color:#fff;*/
    /*color:#000;*/
    text-decoration: underline;
    cursor: pointer;
    /*margin-right:5px;*/
    text-transform: uppercase;
  }
  .step2{
    display:block;
    position: relative;
  }
  .step2 .masks{
    text-align: left;
    position:relative;
    z-index:2;
  }
  .step2 .masks .title {
    display:block;
    border-bottom: 1px solid #000;
    font-size: 19px;
    text-align:center;
    font-weight: bold;
    margin:0;
    letter-spacing: 2px;
    text-transform: uppercase;

  }
  .step2 .masks span{
    display:inline-block;
    vertical-align: middle;
    margin-right:10px;
  }
  .step2 .masks .mask{
    cursor: pointer;
    display:inline-block;
    vertical-align: middle;
    border:1px solid #ccc;
    margin: 5px 0;
    margin-right:5px;
    width:50px;
  }
  .step2 .masks .mask img{
    max-width:100%;
    display:block;
  }
  .step2 .masks .mask:hover,
  .step2 .masks .mask.selected{
    border: 1px solid #fdc043
  }
  .step2 .masks .c.c4{
    display: block;
    position: absolute;
    z-index: 4;
    bottom: -73px;
    left: 10px;
  }
  .playground{
    position:relative;
     z-index:1;
    overflow:hidden;
    margin: 15px 0;
    /*border:1px solid #999;*/
    width:800px;
    margin-left: 50%;
    left: -400px;
    top: -94px;
    margin-bottom: -156px;
    box-sizing:border-box;
  }
  .playground .direction{
    display:none;
    position: absolute;
    right: 134px;
    top: 90px;
    z-index: 4;
    font-size: 28px; 
    height: 71px;
    width: 77px;
    color: #999;
    background: white;
    opacity: 0.5;
    padding: 5px;
    /*display:none;*/
  }
  .playground .direction i{
     position:absolute;
     cursor: pointer;
  }
  .playground .direction i:hover{
    color:gray;
  }
  .playground .direction i.fa-arrow-up{
    top:0;
    left: 50%;
        margin-left: -14px;
  }
  .playground .direction i.fa-arrow-down{
    bottom:0;
    left:50%;
        margin-left: -14px;
  }
  .playground .direction i.fa-arrow-left{
    left:0;
    top:50%;
    margin-top:-15px;
  }
  .playground .direction i.fa-arrow-right{
    right:0;
    margin-top:-15px;
    top: 50%;
  }
  .playground .global{
    position:absolute;
    z-index: 10 !important;
    cursor: pointer;
    font-size:40px;
    display:none;
  }
  .playground .global.fa-arrow-up{
    top: 27%;
    left:50%;
    margin-left:-17px;
  }
  .playground .global.fa-arrow-down{
    top: 65%;
    left:50%;
    margin-left:-17px;
  }
  .playground .global.fa-arrow-left{
    top: 50%;
    left: 24%;
    margin-left: 0;
    margin-top: -20px;
  }
  .playground .global.fa-arrow-right{
    top: 50%;
    right: 24%;
    margin-left: 0;
    margin-top: -20px;
  }


  .playground.playgroundText{
    /* height:300px; */
    height:400px;
    top:0;
    margin-bottom:0;
    background-image: url('https://app.brighton.com/lockets/img/viewport_background.gif') !important;
  }
  .playground.playgroundText span.text1{
    /* top: 166px; */
    top: 213px;
    position: absolute;
    width: 100%;
    line-height: 1.3;
    left: 0;
    font-size:18px;
    z-index:2;
  }
  .playground.playgroundText span.text1.xlarge{
    top: 39%;
  }
  .playground.playgroundText span.text1.xxlarge{
    top: 28%;
  }
  .playground.playgroundText span.text1 span{
    display:block;
    height:23px;
  }
  .playground.playgroundText span.text1.xxlarge span{
    height: 44px;
    font-size: 47px;
  }
  .playground.playgroundText span.text1.xlarge span{
    height:30px;
    font-size:30px;
  }
  .playground.playgroundText span.text1.large span{
    height:23px;
  }
  .playground.playgroundText .locketMask1{
    margin-left:-66px;
    margin-top:-66px;
  }

 
  .playground canvas{
    background-image: url('https://app.brighton.com/lockets/img/viewport_background.gif') !important;
    margin:0 auto;
  }
  .playground .canvas-container{
    margin:0 auto;
    opacity:1;
    z-index:1;
    transition: opacity 0.4s;
  }
  .playground{
    position:relative;
   /* width:auto;
    width:1170px;*/
  }
  .playground .locketMask1{
    display: block;
    position: absolute;
    /* transition: opacity 0.4s; */
    z-index: 4;
    left: 400px;
    left:50%;
    margin-left: -66px;
    margin-left: -63px;
    top: 250px;
    top:50%;
    margin-top: -66px;
    margin-top: -63px;
    pointer-events: none;
  }
  .playground .locketMask2{
    display:block;
    position:absolute;
    /*transition: opacity 0.4s;*/
    z-index:1 !important;;
    left: 400px;
    top: 100px;
  }
  .playground .upper-canvas{
    z-index:2 !important;
  }
  .playground .canvas-container{
    margin:0 auto;
  }
  .playground .canvas-container .grayscale{
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -webkit-filter: grayscale(100%);    /* The WebKit kernel supports well */
    -moz-filter: grayscale(100%);    /* Other kernel does not support for future compatibility, writing */
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%); 
  }

  .control{
    display:block;
    text-align: left;
    position:relative;
    z-index:2;
    padding: 10px;
    background-color: rgb(245, 245, 245);
  }
  .control.c1{
    text-align:right;
    position:relative;
    z-index:3;
    width:100%;
    box-sizing: border-box;
    /*margin-bottom:-20px;*/
        margin-bottom:-37px;
  }
  .control .c{
    display:block;
    margin:10px auto;
  }

  label,
  .control .c label{
    display:inline-block;
    vertical-align: middle;
    margin-right:20px;
    min-width: 130px;
    text-transform: uppercase;
    font-weight: bold;
  }
  .control .c input,
  .control .c img{
    display:inline-block;
    vertical-align: middle;
    /*margin-left:10px;*/
    box-sizing: border-box;
    width:50%;
  }
  .control .c img{
    margin-left:10px;
  }
  .control .c.c1 .fa{
    color:#999;
    font-weight: bold;
    display:inline-block;
    vertical-align: middle;
    margin-right:10px;
  }
  .control .c.c1 .fa:last-child{
    font-size:22px;
    margin-left:15px;
    margin-right:0;
  }
  .control .c.c1 label{
    /*background: url("https://app.brighton.com/lockets/img/a.png") no-repeat;*/
    background-position: 100% 29%;
    /*padding-right: 31px;*/
    background-size: 10px;
  }
  .control .c.c2 label{
    /*background: url("https://app.brighton.com/lockets/img/r.png") no-repeat;*/
    background-position: 100% 29%;
    /*padding-right: 31px;*/
    background-size: 10px;
  }
  .control .c.c2 .fa{
    color:#999;
    /*font-style: italic;*/
    font-weight: light;
    display:inline-block;
    vertical-align: middle;
    margin-right:10px;
    transform: rotate(180deg);
  }
  .control .c.c2 .fa:last-child{
    transform: rotate(0deg);
    font-size:18px;
    margin-left:15px;
    margin-right:0;
  }
  .control .c.c3{
    margin-top:20px;
    text-align: right;
    position: absolute;
    bottom:-65px;
  }
  .control .c.c3.mobile{
    display:none;
  }
  .control .c.c4{
    display:block;
  }
  .control .c.c4.mobile{
    display:none;
  }

  .modal-mask.loadingModal .modal-header{
    /*border-bottom:none !important;*/
  }
  .modal-mask.loadingModal .modal-footer span{
    cursor: pointer;
  }
  .modal-header{
    border-bottom:1px solid #000;
  }
  .step2 .masks{
    padding:10px 0;
    background-color: rgb(245, 245, 245);
  }
  .step2 .masks label{
   margin-left:10px;
  }
@media(max-width:1170px){
  .control .c.c3{
    bottom:-107px;
  }
  .step2 .masks .c.c4{
    bottom:-102px;
  }
}
@media(max-width:1024px) {
  .control{
    padding-bottom:10px;
  }
  .control.c1{
    margin-bottom:-13px;
  }
  .step2 .masks .c.c4,
  .control .c.c4,
  .control .c.c3{
    display:none;
  }
  .control .c.c4.mobile,
  .control .c.c3.mobile{
    display:block;
  }
  .control .c input{
    height:60px;
    margin: 0;
  }
}



@media(max-width:1024px){
   .playground{
     /*margin-top:-100px;*/
     /*margin-bottom:-100px;*/
      top:-100px;
     position:relative;
     z-index:1;
  }
  .playground.playgroundText{
    /* margin-top: 0;
    margin-bottom: 0; */
    top: 0;
    margin-bottom: -92px;
    margin-top: -92px;
  }
  .playground .direction{
    top: 138px;
    right: 33px;
  }
}
@media(max-width:1024px){
   .playground{
     /* margin-bottom:-276px;
     top:-145px; */
     /* margin-bottom: -314px;
    top: -168px; */
    margin-bottom: -332px;
    top: -178px;
  }
  .playground.playgroundText{
    /* margin-top: 0;
    margin-bottom: 0;
    top: 0; */
  }
  .control .c{
    margin:0;
  }
  .control .c.c1,
  .control .c.c2{
    margin-top:-20px;
  }
}

@media(max-width:768px){
  .playground .direction{
    right: 114px;
  }
}
@media(max-width:641px) {
  button,
  button.save{
    float:none;
    width:100%;
    margin-bottom:10px;
  }
  .control .c div{
    width:100%;
  }
}
@media(max-width:612px){
    .playground .direction{
      display:none;
    }
    .playground .global{
      /* display:block; */
    }
}
@media(max-width:511px) {
  .step2 .masks{
    text-align: center;
  }
  label{
    min-width:0;
    width:100%;
    text-align:center;
    margin:10px auto;
  }
  .control .c{
    /*margin-bottom:30px;*/
    text-align: center;
  }
  .control .c input{
    width:73%;
    height:60px;
    margin:0;
    padding:0
  }
  .control .c label{
  /*label{*/
    display:block;
    width:100%;
    margin-top:20px;
    margin-bottom:0;
    text-align:center;
  }
  .control .c.c2 label{
    margin:0;
  }
  .playground{
    /* top:-167px;
    margin-bottom: -315px; */

        top: -167px;
    margin-bottom: -315px;
  }
  .playground.playgroundText{
    /* margin-top: 0;
    top: 0;
    margin-bottom: 0; */
    
  }
  .playground .global{
    outline: auto;
    outline-color: #fff;
    opacity:0.5;
    background-color:#fff;
    /*background:rgba(255,255,255, 0.5);*/
  }
  .playground .global.fa-arrow-up{
    top: 30%;
  }
  .playground .global.fa-arrow-down{
     top: 63%;
  }
  .playground .global.fa-arrow-left{
    left:38%; 
  }
  .playground .global.fa-arrow-right{
    right:37%;
  }
}
</style>
